import styled from 'styled-components'
import { easings } from '../../../styles/vars/easings.style'

export const ViewMoreSvg = styled.svg`
  overflow: hidden;
`

export const ViewMoreCircle = styled.circle`
  stroke-dasharray: 311;
  stroke-dashoffset: ${props => (props.active ? 0 : 311)};
  transition-property: stroke-dashoffset;
  transition-duration: 0.65s;
  transition-timing-function: ${easings.out.quart};
  transition-delay: ${props => (props.active ? undefined : '0.1s')};
`

export const ViewMoreIcon = styled.g`
  transform: ${props => (props.active ? 'translateX(0)' : 'translateX(20%)')};
  opacity: ${props => (props.active ? 1 : 0)};
  transition-property: opacity, transform;
  transition-duration: 0.2s;
  transition-timing-function: ${easings.out.quart};
  transition-delay: ${props => (props.active ? '0.2s' : undefined)};
`
